export default __webpack_public_path__ + "static/media/points.88688067.svg";